export default __webpack_public_path__ + "static/media/header-intro.ee6c27bf.svg";